import whatIsSolidaryEuro from './whatIsSolidaryEuro/whatIsSolidaryEuro';
import amplifyInformation from './amplifyInformation/amplifyInformation';
import solidarityRequestModal from './solidarityRequestModal/solidarityRequestModal';

let solidarityComponents = angular.module('solidarity.components', [
  whatIsSolidaryEuro,
  amplifyInformation,
  solidarityRequestModal,
])
  .name;

export default solidarityComponents;



// WEBPACK FOOTER //
// ./client/app/solidarity.module/components/solidarity.components.js